import React from 'react';
const WrapWidth = /*#__PURE__*/ React.forwardRef(({ width, children }, ref)=>{
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        style: {
            width
        }
    }, children);
});
WrapWidth.displayName = 'WrapWidth';
export default WrapWidth;
